import { render, staticRenderFns } from "./WasteMeasure.vue?vue&type=template&id=65509b9a&"
import script from "./WasteMeasure.vue?vue&type=script&lang=js&"
export * from "./WasteMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports